<template>
  <basic-container>
    <el-dialog
      title="佣金明细"
      :visible.sync="visible"
      :append-to-body="true"
      width="80%"
      @close="cancel"
    >
      <div class="search-contain">
        <el-form ref="query" :model="query" :inline="true" size="mini">
          <el-form-item label="电话/订单号">
            <el-input placeholder="请输入电话/订单号" v-model="query.keyword" clearable />
          </el-form-item>
          <el-form-item label="订单状态" prop="status">
            <el-select v-model="query.status" placeholder="请选择" clearable>
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间" prop="daterange">
            <el-date-picker
              v-model="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 220px"
            />
          </el-form-item>
          <el-form-item label="首单/复购订单">
            <el-select v-model="query.type" placeholder="请选择" clearable>
              <el-option
                v-for="item in orderStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchChange"
              :loading="loading"
            >
              筛选
            </el-button>
            <el-button type="danger" icon="el-icon-delete" @click="searchReset" :loading="loading">
              清空
            </el-button>
            <el-button
              class="add"
              type="primary"
              @click="exportClick"
              icon="el-icon-plus"
              v-loading.fullscreen.lock="exportLoading"
            >
              导出
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <yd-table
        :loading="loading"
        :data="records"
        border
        size="mini"
        @onChange="onTableChange"
        :pagination="pagination"
      >
        <el-table-column label="订单号" prop="orderNo" align="center">
          <template slot-scope="scope">
            <el-badge v-if="scope.row.type === 1" style="margin-top: 10px" value="首单">
              <div style="padding-right: 8px">{{ scope.row.orderNo }}</div>
            </el-badge>
            <div v-else>
              {{ scope.row.orderNo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="statusName" align="center" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">待出行</span>
            <span v-if="scope.row.status === 2">待付款</span>
            <span v-if="scope.row.status === 4">已取消</span>
            <span v-if="scope.row.status === 6">全部退票</span>
            <span v-if="scope.row.status === 7">已完成</span>
            <span v-if="scope.row.status === 8">行程中</span>
            <span v-if="scope.row.status === 9">已改签</span>
          </template>
        </el-table-column>

        <el-table-column label="下单用户" prop="phone" align="center" width="100" />
        <el-table-column label="下单时间" prop="createTime" align="center" />
        <el-table-column label="完单时间/退款时间" prop="finishTime" align="center" />
        <el-table-column label="订单金额（元）" prop="amount" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.amount / 100 }}
          </template>
        </el-table-column>
        <el-table-column label="佣金金额（元）" prop="commission" align="center" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0 || scope.row.status === 8">待返佣</span>
            <span v-else>{{ scope.row.commission / 100 }}</span>
          </template>
        </el-table-column>
      </yd-table>
    </el-dialog>
  </basic-container>
</template>

<script>
  import { postChannelManageDetail } from '@/api/channel'
  import dayjs from 'dayjs'
  import { exportExcelPost } from '@/router/axios.js'
  import env from '@/config/env'
  export default {
    name: 'CommissionList',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      visible() {
        return this.show
      }
    },
    data() {
      return {
        daterange: [],
        // 分页
        pagination: {
          current: 1,
          size: 10,
          total: 0
        },
        loading: false,
        records: [],
        query: {},
        exportLoading: false,
        statusList: [
          { label: '待付款', value: 2 },
          { label: '待出行', value: 0 },
          { label: '行程中', value: 8 },
          { label: '已完成', value: 7 },
          { label: '已改签', value: 9 },
          { label: '已取消', value: 4 },
          { label: '全部退票', value: 6 }
        ],
        orderStatusList: [
          { value: 1, label: '首单' },
          { value: 2, label: '复购订单' }
        ],
        params: {}
      }
    },
    mounted() {
      this.setDate()
    },
    methods: {
      setDate() {
        const today = new Date()
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
        this.daterange = [dayjs(firstDay).format('YYYY-MM-DD'), dayjs(lastDay).format('YYYY-MM-DD')]
      },

      cancel() {
        this.$emit('close')
      },
      onTableChange({ current, pageSize }) {
        this.pagination.current = current
        this.pagination.size = pageSize
        this.initPage()
      },

      async exportClick() {
        if (this.total === 0) {
          this.$message.info('没有数据可以导出')
          return
        }
        const params = this.params
        this.exportLoading = true
        try {
          const { code = 0 } =
            (await exportExcelPost(`${env.ferryUrl}/channelManage/export`, params)) || {}
          if (code !== 0) {
            return
          }
          this.$message.success('文件正在下载中，请关注浏览器下载列表')
        } catch (error) {
          console.log(error)
        } finally {
          this.exportLoading = false
        }
      },

      initPage() {
        let startDate = ''
        let endDate = ''
        if (this.daterange && this.daterange.length !== 0) {
          startDate = this.daterange[0]
          endDate = this.daterange[1]
        }
        this.params = {
          startDate,
          endDate,
          ...this.pagination,
          ...this.query,
          // channelId:68
          ...this.data
        }
        this.getlist(this.params)
      },

      searchChange() {
        this.pagination = {
          current: 1,
          size: 10,
          total: 0
        }
        this.initPage()
      },

      searchReset() {
        this.setDate()
        this.query = {}
        this.pagination = {
          current: 1,
          size: 10,
          total: 0
        }
        this.initPage()
      },

      getlist(params) {
        this.loading = true
        postChannelManageDetail(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.records = data.records
              this.total = data.total
              this.pagination.total = data.total
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>

<style></style>
